import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const defaultGraphStyle = {
  minHeight: '10rem',
  width: '100%',
  height: '100%',
};

interface ChartProps {
  data: any;
  graphStyle?: React.CSSProperties;
}

const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1,
      },
    },
  },
};

const Chart: React.FC<ChartProps> = ({ data, graphStyle = defaultGraphStyle }) => {
  return (
    <div style={graphStyle}>
      <Line data={data} options={options} />
    </div>
  );
};

export default Chart;
